import { getPersonalSummary } from "./balances";
import { countLabel } from "./format";
import { getSettlements } from "./settlements";

export const SETTLED_STATUS_TEXT = "Alles ausgeglichen";

const sameId = (a, b) => a != null && b != null && `${a}` === `${b}`;

export const getSettlementStatus = (participants = [], meId = null) => {
  const count = getSettlements(participants ?? []).length;
  const settled = count === 0;
  const me = settled
    ? null
    : (participants ?? []).find((p) => sameId(p.id, meId));
  return {
    count,
    settled,
    text: settled
      ? SETTLED_STATUS_TEXT
      : `${countLabel(count, "Überweisung", "Überweisungen")} offen`,
    personal: getPersonalSummary(me),
  };
};
